import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xuasb9pf5: FaireProductEntity = {
  token: "p_3xuasb9pf5",
  type: "product",
  name: "Chirps and Cheers Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/92c823d33d2eb17891797fc3da2cc9bc915b79089352c1090ca77ff0dc114442.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/09f06c0c185623fd80140c521bb674397f0e6e0fb97dca533ff7479ef64c649e.jpeg",
    "https://cdn.faire.com/fastly/b9983caa258734cf853ff0dcdf66edaa3cdafb2f6dad476fb897ef6079853616.jpeg",
  ],
  priceDollars: 11,
  description:
    "So this is what birders are actually searching for with all the binoculars? Teeny wine glasses?! Clever birds - no wonder they're so elusive. They're sipping!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:22.321Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
